






import { Vue, Component } from 'vue-property-decorator';
import Paragraph from '@/components/ParagraphWithFold.vue';

@Component({
  components: {
    Paragraph,
  },
})
export default class AParagraphCanFold extends Vue {
  content = '';
  mounted() {
    this.content =
      '陈杲在稳定的前提下，解出了陈秀雄和唐纳森独立提出的 J 方程以及丘成桐等人提出的超临界厄米特 - 杨振宁 - 米尔斯方程的变形。这项结果已经发表在了国际四大顶尖数学期刊之一的 Inventiones Mathematicae（《数学新进展》）上，甚至第一时间还被美国科学院院士劳森等人引用。';
  }
}
